module.exports = __webpack_public_path__ + "static/goenndir-3f3d37075698751f6f3c8c2697e78e8d.jpg";